import { Component } from '@angular/core';
import { DealerStateSelectors } from '@app/core/states/dealer/dealer-state.selectors';
import { select } from '@ngxs/store';

@Component({
  selector: 'app-trade-in-terms',
  templateUrl: './trade-in-terms.component.html',
  styleUrl: './trade-in-terms.component.scss',
  standalone: true,
})
export class TradeInTermsComponent {
  isRetailPayment = select(DealerStateSelectors.isRetailPayment);
}
